(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2830],{

/***/ 81907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17192);
/* harmony import */ var _customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var _NewPhotoSwipe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3024);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69587);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63385);












var CustomProductGallery = function(param) {
    var images = param.images, dbName = param.dbName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentIndex = ref1[0], setCurrentIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nav1 = ref2[0], setNav1 = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nav2 = ref3[0], setNav2 = ref3[1];
    var showArrows = function(slidesToShow) {
        return images.length > slidesToShow;
    };
    var settings = {
        slidesToShow: 4,
        arrows: showArrows(4),
        infinite: images.length > 4,
        centerMode: true,
        centerPadding: "0",
        swipeToSlide: true,
        focusOnSelect: true,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_4__/* .CarouselNext */ .Pz, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_4__/* .CarouselPrev */ .X$, {}),
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    infinite: images.length > 3,
                    arrows: showArrows(3)
                }
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 2,
                    infinite: images.length > 2,
                    arrows: showArrows(2)
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    infinite: images.length > 4,
                    arrows: showArrows(4)
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 3,
                    infinite: images.length > 3,
                    arrows: showArrows(3)
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 2,
                    infinite: images.length > 2,
                    arrows: showArrows(2)
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isOpen) {
            var initializeGallery = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
                    var options, items, ref, PhotoSwipe, ref1, PhotoSwipeUI_Default, gallery;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = {
                                    index: currentIndex,
                                    bgOpacity: 0.9,
                                    history: false
                                };
                                items = images.map(function(image) {
                                    return {
                                        src: (0,_helper__WEBPACK_IMPORTED_MODULE_6__/* .domainUrl */ .HJ)("".concat(dbName, "/").concat(image)),
                                        msrc: (0,_helper__WEBPACK_IMPORTED_MODULE_6__/* .domainUrl */ .HJ)("".concat(dbName, "/").concat(image)),
                                        w: 1000,
                                        h: 1000
                                    };
                                });
                                return [
                                    4,
                                    __webpack_require__.e(/* import() */ 8832).then(__webpack_require__.t.bind(__webpack_require__, 58832, 23))
                                ];
                            case 1:
                                ref = _state.sent(), PhotoSwipe = ref.default;
                                return [
                                    4,
                                    __webpack_require__.e(/* import() */ 8411).then(__webpack_require__.t.bind(__webpack_require__, 38411, 23))
                                ];
                            case 2:
                                ref1 = _state.sent(), PhotoSwipeUI_Default = ref1.default;
                                gallery = new PhotoSwipe(document.querySelector(".pswp"), PhotoSwipeUI_Default, items, options);
                                gallery.init();
                                gallery.listen("beforeChange", function() {
                                    var index = gallery.getCurrentIndex();
                                    nav1 === null || nav1 === void 0 ? void 0 : nav1.slickGoTo(index);
                                    setCurrentIndex(index);
                                });
                                gallery.listen("close", function() {
                                    setIsOpen(false);
                                });
                                return [
                                    2,
                                    function() {
                                        gallery.destroy();
                                    }
                                ];
                        }
                    });
                });
                return function initializeGallery() {
                    return _ref.apply(this, arguments);
                };
            }();
            initializeGallery().then(function(r) {
                return r;
            });
        }
    }, [
        isOpen
    ]);
    var openGallery = function(index) {
        setIsOpen(true);
        setCurrentIndex(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default().product_gallery), " ").concat(isOpen ? (_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default().product_gallery_priority) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["product-gallery__featured"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NewPhotoSwipe__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        asNavFor: nav2,
                        ref: function(slider) {
                            return setNav1(slider);
                        },
                        arrows: false,
                        children: images.map(function(image, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image_wrapper),
                                onClick: function() {
                                    return openGallery(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        src: (0,_helper__WEBPACK_IMPORTED_MODULE_6__/* .domainUrl */ .HJ)("".concat(dbName, "/").concat(image)),
                                        alt: "product image",
                                        layout: "fill",
                                        objectFit: "contain",
                                        priority: true,
                                        loading: "eager",
                                        sizes: "(max-width: 425px) 385px, (max-width: 768px) 730px, (max-width: 1200px) 555px, 585px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        "aria-label": "image zoom",
                                        className: (_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["product-gallery__zoom"]),
                                        onClick: function() {
                                            return openGallery(index);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_4__/* .ZoomIn24Svg */ .Jx, {})
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            images.length > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["product-gallery__carousel"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                    asNavFor: nav1,
                    ref: function(slider) {
                        return setNav2(slider);
                    }
                }, settings), {
                    children: images.map(function(image, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_customInnerPage_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image_wrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                src: (0,_helper__WEBPACK_IMPORTED_MODULE_6__/* .domainUrl */ .HJ)("".concat(dbName, "/").concat(image)),
                                alt: "product image",
                                layout: "fill",
                                objectFit: "contain",
                                loading: "lazy",
                                sizes: "60px"
                            })
                        }, index);
                    })
                }))
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomProductGallery);


/***/ }),

/***/ 48168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69587);






var InputNumber = function(_param) {
    var _min = _param.min, min = _min === void 0 ? null : _min, size = _param.size, onChange = _param.onChange, hideMinusButton = _param.hideMinusButton, className = _param.className, alternativelyRemoveButton = _param.alternativelyRemoveButton, value = _param.value, _step = _param.step, step = _step === void 0 ? 1 : _step, _max = _param.max, max = _max === void 0 ? null : _max, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "min",
        "size",
        "onChange",
        "hideMinusButton",
        "className",
        "alternativelyRemoveButton",
        "value",
        "step",
        "max"
    ]);
    var handleChange = function(event) {
        if (onChange) {
            if (event.target.value.trim() === "") {
                onChange(Number(""));
            } else {
                var value = parseFloat(event.target.value);
                onChange(Number.isNaN(value) ? min || 0 : value);
            }
        }
    };
    var handleAddSubMouseDown = function(arg) {
        change(arg);
        changeByTimer(arg);
    };
    var change = function(direction) {
        var newValue = (!value || Number.isNaN(value) ? 0 : value) + step * direction;
        if (max !== null) {
            newValue = Math.min(max, newValue);
        }
        if (min !== null) {
            newValue = Math.max(min, newValue);
        }
        if (newValue !== value) {
            if (onChange) {
                onChange(newValue);
            }
        }
    };
    var changeByTimer = function(direction) {
        var interval;
        var timer = setTimeout(function() {
            interval = setInterval(function() {
                return change(direction);
            }, 50);
        }, 3000);
        var documentMouseUp = function() {
            clearTimeout(timer);
            clearInterval(interval);
            document.removeEventListener("mouseup", documentMouseUp, false);
        };
        document.addEventListener("mouseup", documentMouseUp, false);
    };
    var classes = {
        true: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-number"]),
        false: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-number"]), " ").concat(className || "")
    };
    var formControlClasses = {
        true: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-number__input"]), "  ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["cart-quantity-responsive"])),
        false: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-number__input"]), "  ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["cart-quantity-responsive"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-control-sm"]))
    };
    var minusButton = {
        true: alternativelyRemoveButton,
        false: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            style: {
                background: "linear-gradient(180deg, #EEE 0%, #D5D5D5 100%)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .InputMinus */ .jI, {
                className: hideMinusButton ? (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default().minus_hide) : (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-number__sub"]),
                onMouseDown: function() {
                    return handleAddSubMouseDown(-1);
                }
            })
        })
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes["".concat(!!className)],
        children: [
            minusButton["".concat(!!hideMinusButton)],
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: formControlClasses["".concat(size === "sm")],
                type: "number",
                onChange: handleChange,
                value: value,
                style: {
                    width: "60px"
                }
            }, otherProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                style: {
                    background: "linear-gradient(180deg, #EEE 0%, #D5D5D5 100%)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .InputPlus */ .nV, {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-number__add"]),
                    onMouseDown: function() {
                        return handleAddSubMouseDown(1);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 17192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-header":"customInnerPage_page-header__0_mXE","page-header__container":"customInnerPage_page-header__container__MQBWL","page-header__breadcrumb":"customInnerPage_page-header__breadcrumb__Nf9OS","breadcrumb":"customInnerPage_breadcrumb__DP8wK","breadcrumb-item":"customInnerPage_breadcrumb-item__W8TfH","breadcrumb-arrow":"customInnerPage_breadcrumb-arrow__iBgCh","breadcrumb-item-active":"customInnerPage_breadcrumb-item-active__4YwnH","inner-buttons-wrapper":"customInnerPage_inner-buttons-wrapper__mgfKz","like-btn-self-flex":"customInnerPage_like-btn-self-flex__8ecBD","inner-wishlist":"customInnerPage_inner-wishlist__a3HeB","options_main":"customInnerPage_options_main__quIh_","err-block":"customInnerPage_err-block__LqFgR","product__content":"customInnerPage_product__content__ROCx8","product_gallery_priority":"customInnerPage_product_gallery_priority__uASxb","product_gallery":"customInnerPage_product_gallery__QU9PA","product-gallery__featured":"customInnerPage_product-gallery__featured__eQMQK","image_wrapper":"customInnerPage_image_wrapper__VfbqS","product-gallery__zoom":"customInnerPage_product-gallery__zoom__Wb2rl","product-gallery__arrows":"customInnerPage_product-gallery__arrows__5uQ7J","product-gallery__carousel":"customInnerPage_product-gallery__carousel__21ptU","product__info":"customInnerPage_product__info__tMwH8","product__name":"customInnerPage_product__name__xWSyM","product__sku":"customInnerPage_product__sku__UnBa5","configurable-attributes":"customInnerPage_configurable-attributes__xkUIF","each__option":"customInnerPage_each__option__6J8qJ","option_title":"customInnerPage_option_title__U8JJu","select__option":"customInnerPage_select__option__zO_4_","option_label":"customInnerPage_option_label__jT7TO","dropdown_btn":"customInnerPage_dropdown_btn__qS9Rz","drop_down_arrow":"customInnerPage_drop_down_arrow__Wu0LZ","drop_down_opened":"customInnerPage_drop_down_opened__Nm9rO","options_dropdown":"customInnerPage_options_dropdown__RA7Bf","selected":"customInnerPage_selected__9aXu_","text__option":"customInnerPage_text__option__bG23g","auto-expand":"customInnerPage_auto-expand__ktwE1","product__price":"customInnerPage_product__price__tdM1d","product-card__new-price":"customInnerPage_product-card__new-price__NuWxU","product-card__old-price":"customInnerPage_product-card__old-price___8syV","price_value":"customInnerPage_price_value__O9TYF","with_cost":"customInnerPage_with_cost__2RySR","price_title":"customInnerPage_price_title__1fYzC","product-inner-description-title":"customInnerPage_product-inner-description-title__mivuX","promotion_price_summary":"customInnerPage_promotion_price_summary__bjdPg","promotion_price_summary__row":"customInnerPage_promotion_price_summary__row__GcJo2","product-inner-chart-title":"customInnerPage_product-inner-chart-title__xO7CP","config_filters":"customInnerPage_config_filters__qRonk","attr_fms":"customInnerPage_attr_fms__6T5nq","attr_color_fms":"customInnerPage_attr_color_fms__rWgSJ","color-attr_fm":"customInnerPage_color-attr_fm__rRyUw","other-attr_fm":"customInnerPage_other-attr_fm__inVC3","filter-color__item":"customInnerPage_filter-color__item__yb_fx","attr_space":"customInnerPage_attr_space__LoZXs","attr_label_size":"customInnerPage_attr_label_size___aooA","input-check-color":"customInnerPage_input-check-color__nsCYQ","input-check-color--white":"customInnerPage_input-check-color--white__RZaSy","input-check-color__box":"customInnerPage_input-check-color__box__mA8Nt","input-check-color__icon":"customInnerPage_input-check-color__icon__IbGPM","input-check-color__body":"customInnerPage_input-check-color__body__9k_V7","input-check-color__input":"customInnerPage_input-check-color__input__qH7TS","input-check-color__stick":"customInnerPage_input-check-color__stick__u9UTt","other-list-main-fms":"customInnerPage_other-list-main-fms__iJKwb","label-attr__code":"customInnerPage_label-attr__code__SCCPW","other-radio__input":"customInnerPage_other-radio__input__DL0Fg","product__meta":"customInnerPage_product__meta__2ZJEa","product__meta-availability":"customInnerPage_product__meta-availability__eHShU","quantity_table_title":"customInnerPage_quantity_table_title__ZMzHt","quantity_table_main":"customInnerPage_quantity_table_main__GPesU","quantity_table_row":"customInnerPage_quantity_table_row__cBpoE","quantity_table_item":"customInnerPage_quantity_table_item___18cy","quantity_item_span":"customInnerPage_quantity_item_span__gXDX3","price_item_span":"customInnerPage_price_item_span__5Wonp","product-inner-quantity":"customInnerPage_product-inner-quantity__Wft0a","sidebar__details":"customInnerPage_sidebar__details__3mLb8","simple__meta":"customInnerPage_simple__meta__1yPAy","product__sidebar":"customInnerPage_product__sidebar__hrHIK","product__options":"customInnerPage_product__options___PxXs","product__option":"customInnerPage_product__option__a1o_4","downloadable__links":"customInnerPage_downloadable__links__jJ8Yk","links__heading":"customInnerPage_links__heading__r6Znc","product__samples_container":"customInnerPage_product__samples_container__4RhRF","product__links_container":"customInnerPage_product__links_container__Co2_M","product__samples":"customInnerPage_product__samples__msMhU","product__links":"customInnerPage_product__links__Qkmly","sample__link":"customInnerPage_sample__link__zbiEV","sample__links__items":"customInnerPage_sample__links__items__d_9Oi","product__variant":"customInnerPage_product__variant__AWa_V","variant__link":"customInnerPage_variant__link__vATzj","variant__sample":"customInnerPage_variant__sample__b7j6v","links__sample__items":"customInnerPage_links__sample__items__PEaX5","required__text":"customInnerPage_required__text__iQqi_","product__actions":"customInnerPage_product__actions__UeO8x","product__actions-item":"customInnerPage_product__actions-item__wGlVr","product__actions-item--addToCart":"customInnerPage_product__actions-item--addToCart__eUjj6","inner-addToCart":"customInnerPage_inner-addToCart__xYRGS","liked-button-wrapper":"customInnerPage_liked-button-wrapper__KCUs3","wishlist-icon-wrapper":"customInnerPage_wishlist-icon-wrapper__pVhAm","socialLinksBox":"customInnerPage_socialLinksBox__hiVKb","upsell_body":"customInnerPage_upsell_body__Pohjm","ups-product__info":"customInnerPage_ups-product__info__GA3Xk","product__prices":"customInnerPage_product__prices__T_5vv","currency_value":"customInnerPage_currency_value__x91cr","short_description_block":"customInnerPage_short_description_block__veWY5","no-thanks":"customInnerPage_no-thanks__VXMi_","tab_buttons":"customInnerPage_tab_buttons__tvzpr","tab":"customInnerPage_tab__VmSnt","tab_description-active":"customInnerPage_tab_description-active__0wAk8","tab_detail-active":"customInnerPage_tab_detail-active__JT6Cn","details_block":"customInnerPage_details_block__xP3KL","detail_row":"customInnerPage_detail_row__JduLG","detail_key":"customInnerPage_detail_key__c6jqP","detail_value":"customInnerPage_detail_value__Y39mB","detail_value_open":"customInnerPage_detail_value_open__4wmh8","detail_content":"customInnerPage_detail_content__WbAF9","icon_for_open":"customInnerPage_icon_for_open__yAaTj","read_more":"customInnerPage_read_more__dNzYd","active":"customInnerPage_active__APvtE","related_block":"customInnerPage_related_block__MmAuV","main_popup_img_wrapper":"customInnerPage_main_popup_img_wrapper__0hWA_","main_popup_img":"customInnerPage_main_popup_img__bpjOA","chart_main":"customInnerPage_chart_main__7ixuC","wr_dropDown_name":"customInnerPage_wr_dropDown_name__P55LV","dropdown_open_btn":"customInnerPage_dropdown_open_btn__K4ChS","open":"customInnerPage_open__NKWF5","wr_img_dropDown_name":"customInnerPage_wr_img_dropDown_name__lJ73H","selected_configue":"customInnerPage_selected_configue__YSC79"};

/***/ })

}]);